import { render } from "./KarussellHotel1.vue?vue&type=template&id=6be642e9"
import script from "./KarussellHotel1.vue?vue&type=script&lang=js"
export * from "./KarussellHotel1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__